module.exports = __webpack_public_path__ + "img/13.75c0cdd9.png";